import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/models/user';
import { TeamService } from 'src/app/services/team.service';
import { Team } from 'src/app/models/team';
import { Define } from 'src/app/models/define';
import { UserService } from 'src/app/services/user.service';
import { Firestore } from '@angular/fire/firestore';
import { doc } from 'firebase/firestore';

@Component({
  selector: 'app-user-manage-dialog',
  templateUrl: './user-manage-dialog.component.html',
  styleUrls: ['./user-manage-dialog.component.css']
})
export class UserManageDialogComponent implements OnInit {
  password: string;
  teams: Team[];
  authorities = Define.AuthorityName;
  manageAuthorities = Define.ManageAuthorityName;
  teamId: string;
  isNewUser: boolean;
  isTagIdErr: boolean;
  isEmailExist: boolean;
  isInvalidEmail: boolean;
  isRegisterErr: boolean;
  isInvalidKana: boolean;
  constructor(
    private firestore: Firestore,
    public auth: AuthService,
    private teamService: TeamService,
    private userService: UserService,
    private dialogRef: MatDialogRef<UserManageDialogComponent>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public keySet: User) { }

  async ngOnInit() {
    if (this.keySet.email === '') {
      this.isNewUser = true;
    } else {
      this.isNewUser = false;
    }

    if (this.keySet.team == null) {
      this.teamId = '';
    } else {
      this.teamId = this.keySet.team.id;
    }
    this.teams = await this.teamService.getTeams();

  }

  validateTagId() {
    if (this.keySet.key === undefined || this.keySet.key === '') {
      return false;
    }
    return true;
  }

  async request() {
    console.log('request called');
    this.keySet.team = this.teamId ? doc(this.firestore, 'team', this.teamId) : undefined;

    let err = false;
    // メールアドレスの形式をチェックする。
    if (this.userService.isValidEmail(this.keySet.email)) {
      this.isInvalidEmail = false;
    } else {
      this.isInvalidEmail = true;
      err = true;
    }
    // ふりがなの形式をチェックする。
    if (this.userService.isValidKana(this.keySet.kana)) {
      this.isInvalidKana = false;
    } else {
      this.isInvalidKana = true;
      err = true;
    }
    // メールアドレスの重複をチェックする。
    if (this.isNewUser) {
      if (await this.userService.isUniqueEmail(this.keySet.email)) {
        this.isEmailExist = false;
      } else {
        this.isEmailExist = true;
        err = true;
      }
    }
    // カードIDの重複をチェックする。
    if (await this.userService.isUniqueKeyId(this.keySet)) {
      this.isTagIdErr = false;
    } else {
      this.isTagIdErr = true;
      err = true;
    }
    if (err) {
      return;
    }
    if (this.isNewUser) {
      const result = await this.userService.createUser(this.keySet, this.password);
      if (result !== true) {
        // nop
        this.isRegisterErr = true;
        return;
      } else {
        this.isRegisterErr = false;
      }

    } else {
      await this.userService.updateUser(this.keySet);
      // await this.afStore.collection('users').doc(this.keySet.uid).set(this.keySet);
    }

    this.showSnackbar('保存しました！');
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }


  async showSnackbar(text: string){
    this._snackBar.open(text, undefined, { duration: 2 * 1000 });
  }
}
